import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var PrivacySVG = function PrivacySVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M41.233,24.509h0a2.622,2.622,0,0,0-3.707,0l-3.805,3.805A.655.655,0,0,1,32.6,27.85V8.382a2.717,2.717,0,0,0-2.181-2.725,2.622,2.622,0,0,0-3.06,2.584v9.828a.656.656,0,0,1-1.311,0V5.761a2.717,2.717,0,0,0-2.18-2.725A2.623,2.623,0,0,0,20.81,5.621V18.069a.655.655,0,1,1-1.31,0V8.382a2.717,2.717,0,0,0-2.181-2.725,2.622,2.622,0,0,0-3.061,2.584v9.828a.655.655,0,1,1-1.31,0V11a2.719,2.719,0,0,0-2.181-2.725,2.623,2.623,0,0,0-3.061,2.585V30.517A10.483,10.483,0,0,0,18.189,41h4.83a13.1,13.1,0,0,0,9.266-3.838h0l8.948-8.948h0A2.62,2.62,0,0,0,41.233,24.509Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M37.391,22.9C31.183,15.519,25.3,13,20.141,13,11.889,13,5.5,19.465,2.6,22.923a2.582,2.582,0,0,0,.013,3.316c6.208,7.378,12.1,9.9,17.25,9.9,8.252,0,14.64-6.466,17.545-9.924A2.582,2.582,0,0,0,37.391,22.9ZM4.563,24.581a30.942,30.942,0,0,1,7.558-6.62,10.258,10.258,0,0,0,.193,13.42A29.752,29.752,0,0,1,4.563,24.581ZM20,32.28a7.712,7.712,0,1,1,7.712-7.712A7.717,7.717,0,0,1,20,32.28Zm7.879-1.105a10.256,10.256,0,0,0-.193-13.419,29.765,29.765,0,0,1,7.751,6.8A30.942,30.942,0,0,1,27.879,31.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M23.856,24.568A3.856,3.856,0,1,1,20,20.712a3.732,3.732,0,0,1,1.144.18A1.9,1.9,0,0,0,20,22.64a1.925,1.925,0,0,0,1.928,1.928,1.9,1.9,0,0,0,1.748-1.144A3.732,3.732,0,0,1,23.856,24.568Z"
  }));
};
PrivacySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
PrivacySVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Privacy")
};
export default withDetailedIcon(PrivacySVG);